module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sites"
  }, [_c('div', {
    staticClass: "panelheader border-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/admin/clients'
      }
    }
  }, [_vm._v("Clients Admin")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/admin/clients/' + _vm.clientId
      }
    }
  }, [_vm._v(_vm._s(_vm.pageName))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "add"
    },
    on: {
      "click": _vm.onNewSite
    }
  }, [_vm._v("New Site")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sites"
  }, [_c('h2', [_vm._v(_vm._s(_vm.clientName))]), _vm._v(" "), (_vm.newSite) ? _c('div', [_c('newsite', {
    attrs: {
      "clientId": _vm.clientId
    },
    on: {
      "close": _vm.onClose
    }
  })], 1) : (_vm.editSite) ? _c('div', [_c('editsite', {
    attrs: {
      "siteData": _vm.siteData
    },
    on: {
      "close": _vm.onClose
    }
  })], 1) : _c('div', [(!_vm.reloading) ? _c('sitetable', {
    attrs: {
      "id": _vm.clientId
    },
    on: {
      "editSite": _vm.onEditSite,
      "deleteSite": _vm.onDeleteSite
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ca6d57","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Sites/Sites.vue
// module id = 1004
// module chunks = 10